/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ChatDefs from "./defs.defs.js";

const $nsid = "place.stream.chat.getReplay";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"video":/*#__PURE__*/ l.string({"format":"at-uri"}),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":1000}), 500)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"messages":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<ChatDefs.MessageView>((() => ChatDefs.messageView) as any), ),"livestreams":/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"format":"at-uri"}), ),"startedAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** The chat of the livestream a video is the recording of, for a read-only replay beside it. Follows the video's connections to place.stream.livestream records of its own author (the records a recording is connected to when it is published as a video) and returns their messages oldest first, with the time the recording started so a player can show each message at the moment it was sent. Empty for a video that is not the recording of a livestream. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["VideoNotFound"]);

export { main };

export const $lxm = $nsid;
